export interface Taxonomy {
    id: number;
    name: string;
    parentId: number | null;
    depth: number;
    permalink: string;
    children: Taxonomy[];
}
